import { useEffect, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'

export function useEventStream() {
  const queryClient = useQueryClient()
  const [connected, setConnected] = useState(false)

  useEffect(() => {
    const events = new EventSource('/api/v1/events')
    const connectedHandler = () => setConnected(true)
    const catalogHandler = () => {
      queryClient.invalidateQueries({ queryKey: ['catalog'] })
      queryClient.invalidateQueries({ queryKey: ['system-status'] })
    }
    const downloadHandler = () => {
      queryClient.invalidateQueries({ queryKey: ['downloads'] })
      queryClient.invalidateQueries({ queryKey: ['subscription-preview'] })
      queryClient.invalidateQueries({ queryKey: ['subscription-statistics'] })
    }
    const libraryAvailabilityHandler = () => {
      queryClient.invalidateQueries({ queryKey: ['catalog'] })
      queryClient.invalidateQueries({ queryKey: ['new-movies'] })
      queryClient.invalidateQueries({ queryKey: ['discoveries'] })
      queryClient.invalidateQueries({ queryKey: ['system-status'] })
    }
    const subscriptionHandler = () => {
      queryClient.invalidateQueries({ queryKey: ['subscriptions'] })
      queryClient.invalidateQueries({ queryKey: ['subscription-preview'] })
      queryClient.invalidateQueries({ queryKey: ['subscription-statistics'] })
    }
    const notificationHandler = () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] })
      queryClient.invalidateQueries({ queryKey: ['subscriptions'] })
      queryClient.invalidateQueries({ queryKey: ['subscription-statistics'] })
    }
    const rootsHandler = () => {
      queryClient.invalidateQueries({ queryKey: ['media-roots'] })
      queryClient.invalidateQueries({ queryKey: ['system-status'] })
    }
    events.addEventListener('connected', connectedHandler)
    events.addEventListener('catalog-status', catalogHandler)
    events.addEventListener('download', downloadHandler)
    events.addEventListener('library-availability', libraryAvailabilityHandler)
    events.addEventListener('subscription', subscriptionHandler)
    events.addEventListener('subscription-deleted', subscriptionHandler)
    events.addEventListener('notification', notificationHandler)
    events.addEventListener('media-roots', rootsHandler)
    events.onerror = () => setConnected(false)
    return () => events.close()
  }, [queryClient])

  return connected
}
